import { Injectable } from '@angular/core';
import { FeathersAppService, FeathersServiceClass } from '@fire/feathers';
import { fireLogger } from '../../core/utils/fire-logger';
import { FeathersConnectionNames } from '../../core/config/feathers-connection-names';


@Injectable()
export class NewEntryService extends FeathersServiceClass {



  constructor(
    feathersAppService:FeathersAppService,
  ) {
    super(feathersAppService);
    fireLogger.log('initializing new-entries service --- CONSTRUCTOR');

    this.init(FeathersConnectionNames.Main, {
      serviceName: 'new-entries',
      timeout: 5 * 60000,
    });
  }






}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/new-entry.service.ts